// components/Footer.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Ajoutez useNavigate
import logo from "../assets/logo_ivt.png";
import './Footer.css';
import { HiOutlineMapPin, HiOutlinePhone, HiOutlineEnvelope } from "react-icons/hi2";

const Footer = () => {
  const navigate = useNavigate(); // Hook pour la navigation

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // // Fonction pour naviguer vers la section "qui-est-ce-pour" - MÊME LOGIQUE QUE DANS NAVIGATION
  // const navigateToDevenirFormateur = () => {
  //   if (window.location.pathname === "/") {
  //     // Si déjà sur la page d'accueil
  //     const element = document.getElementById("qui-est-ce-pour");
  //     if (element) {
  //       // Scroll vers la section
  //       element.scrollIntoView({ behavior: "smooth" });

  //       // Nettoyer l'URL en enlevant l'ancre si elle existe
  //       if (window.location.hash) {
  //         // Remplacer l'URL actuelle sans recharger la page
  //         window.history.replaceState(null, "", window.location.pathname);
  //       }
  //     }
  //   } else {
  //     // Si sur une autre page, naviguer vers l'accueil SANS ancre
  //     navigate("/");

  //     // Attendre que la page se charge puis scroll vers la section
  //     setTimeout(() => {
  //       const element = document.getElementById("qui-est-ce-pour");
  //       if (element) {
  //         element.scrollIntoView({ behavior: "smooth" });
  //       }
  //     }, 100);
  //   }
  // };

  // Fonction pour naviguer vers une section avec scroll vers le haut
  const navigateToSection = (sectionId) => {
    if (window.location.pathname === '/') {
      // Si déjà sur la page d'accueil
      scrollToSection(sectionId);
    } else {
      // Si sur une autre page, naviguer vers l'accueil
      navigate('/');
      // Attendre un peu que la page se charge puis scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  // Fonction pour naviguer vers une page avec scroll vers le haut
  const navigateToPage = (path) => {
    navigate(path);
    // Scroll vers le haut après la navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
  };

  // Fonctions pour ouvrir les liens dans un nouvel onglet
  const openMentionsLegales = () => {
    window.open('https://inovact.com/mentions-legales.html', '_blank', 'noopener,noreferrer');
  };

  const openPolitiqueConfidentialite = () => {
    window.open('https://inovact.com/politique-confidentialite.html', '_blank', 'noopener,noreferrer');
  };

  const openEtrainApp = () => {
    window.open('https://etrainapp.ivtapp.com', '_blank', 'noopener,noreferrer');
  };

  const openPartenaire = () => {
    window.open('https://etrainapp.ivtapp.com/Devenir-partenaire', '_blank', 'noopener,noreferrer');
  };

  // Fonction pour gérer les redirections vers contact avec sujet
  const navigateToContact = (subject) => {
    navigate(`/contactez-nous?subject=${encodeURIComponent(subject)}`);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
  };

  return (
    <footer className="footer">
      {/* Bandeau coloré en haut */}
      <div className="section-row">
        <div className="bg-green"></div>
        <div className="bg-green"></div>
        <div className="bg-green"></div>
      </div>

      <div className="footer-main">
        {/* Première ligne : Logo et navigation horizontale */}
        <div className="footer-top-row">
          <div className="footer-logo-section d-flex">
            <img src={logo} alt="Logo Inovact" className="footer-logo" />
          </div>

          <div className="footer-nav-section">
            <div className="footer-nav">
              {/* TOUS LES 8 BOUTONS SUR UNE SEULE LIGNE */}
              <div className="footer-nav-single-row">
                {/* Accueil - Redirige vers la page d'accueil */}
                <button
                  onClick={() => navigateToPage('/')}
                  className="footer-nav-link"
                >
                  Accueil
                </button>

                {/* Formations - Scroll vers la section sur la page d'accueil */}
                <button
                  onClick={() => navigateToPage("/entreprises")}
                  className="footer-nav-link"
                >
                  Entreprise
                </button>

                {/* Formations - Scroll vers la section sur la page d'accueil */}
                <button
                  onClick={() => navigateToPage('/formations')}
                  className="footer-nav-link"
                >
                  Académie
                </button>

                {/* Digitalisation - Scroll vers la section sur la page d'accueil */}
                {/* <button 
                  onClick={() => navigateToPage('/centre-examen')} 
                  className="footer-nav-link"
                >
                  Centre d'examen
                </button> */}

                {/* Consulting - Scroll vers la section sur la page d'accueil */}
                <button
                  onClick={() => navigateToPage('/pourquoi-nous')}
                  className="footer-nav-link"
                >
                  Pourquoi-nous ?
                </button>

                {/* Blog - Scroll vers la section sur la page d'accueil */}
                <button
                  onClick={() => navigateToPage('/blog')}
                  className="footer-nav-link"
                >
                  Blog
                </button>

                {/* A propos de nous - Redirige vers la page spécifique */}
                {/* <button 
                  onClick={() => navigateToPage('/a-propos-de-nous')} 
                  className="footer-nav-link"
                >
                  Support
                </button> */}

                {/* Contact - Redirige vers la page spécifique */}
                <button
                  onClick={() => navigateToPage('/contactez-nous')}
                  className="footer-nav-link"
                >
                  Contact
                </button>

                <button
                  onClick={openPartenaire}
                  className="footer-nav-link"
                >
                  Devenir partenaire
                </button>

                {/*  */}
                {/* <button
                  onClick={openEtrainApp}
                  className="footer-nav-link"
                >
                  eTrainApp
                </button>   */}

                <a
                  href="https://etrainapp.ivtapp.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="top-btn-parrainer"
                  style={{ fontSize: "13px", textDecoration: "none" }}
                >
                  eTrainApp
                </a>

              </div>
            </div>
          </div>
        </div>

        <div className="footer-mention">
          <p>
            PMP<sup>®</sup>, CAPM<sup>®</sup>, PMI-CP<sup>™</sup> and the PMI Authorized Training Partner logo are registred marks of the Project Management Institute Inc.
          </p>
          <p>
            ITIL<sup>®</sup> logo is registred marks of the AXELOS Limited.
          </p>
        </div>

      </div>

      {/* Section bas du footer */}
      <div className="footer-bottom">
        <p className="copyright">
          © 2026 Tous droits réservés | Réalisé par INOVACT SARL
        </p>
        <div className="legal-links">
          <span
            className="legal"
            // onClick={openPolitiqueConfidentialite}
            onClick={() => navigateToPage('/politique-confidentialite')}
            style={{ cursor: 'pointer' }}
          >
            Politique de confidentialité
          </span>
          <span
            className="legal"
            onClick={() => navigateToPage('/mentions-legales')}
            style={{ cursor: 'pointer' }}
          >
            Mentions légales
          </span>
        </div>
      </div>

      <style jsx>{`
        /* Style pour desktop - navigation sur 2 lignes */
        .footer-nav {
          display: flex;
          flex-direction: column;
          gap: 10px;
          justify-content: flex-end;
        }
        
        .footer-nav-row {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          justify-content: flex-end;
          align-items: center;
        }
        
        .footer-nav button {
          font-size: 0.85rem;
          color: #1a3c5e;
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px 12px;
          text-align: center;
          transition: all 0.3s ease;
          border-radius: 4px;
          white-space: nowrap;
        }
        
        /* HOVER ORIGINAL - NE PAS CHANGER */
        .footer-nav button:hover {
          color: #1a3c5e;
          font-weight: 700;
        }
        
        /* Section bas du footer - Desktop */
        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          margin-top: 30px;
          width: 100%;
        }
        
        .legal-links {
          display: flex;
          gap: 30px;
          align-items: center;
        }
        
        .legal {
          color: white;
          font-size: 0.9rem;
          cursor: pointer;
          transition: color 0.3s ease;
          white-space: nowrap;
        }
        
        .legal:hover {
          color: #ffd400;
        }
        
        .copyright {
          color: white;
          font-size: 0.9rem;
          white-space: nowrap;
        }
        
        /* Mobile - affichage 2 liens par ligne */
        @media (max-width: 768px) {
          .footer-main {
            padding-top: 20px;
          }
          
          .footer-top-row {
            margin-bottom: 30px;
            gap: 20px;
            align-items: flex-start;
          }
          
          .footer-logo-section {
            align-self: flex-start;
            margin-right: auto;
          }

          /* Sur mobile: une seule colonne */
          .footer-nav {
            flex-direction: column;
            gap: 0;
          }
          
          .footer-nav-row {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
            width: 100%;
            max-width: 400px;
          }
          
          .footer-nav button {
            font-size: 0.9rem;
            white-space: normal;
            text-align: left;
            padding: 8px 5px;
            transition: all 0.3s ease;
          }
          
          /* HOVER ORIGINAL SUR MOBILE AUSSI */
          .footer-nav button:hover {
            color: #ffd400; /* JAUNE D'ORIGINE */
          }
          
          .section-subtitle0 {
            font-size: 1.3rem;
            text-align: left;
            padding-bottom: 15px;
          }
          
          .contact-detail {
            font-size: 0.9rem;
            text-align: left;
            justify-content: flex-start;
            align-items: center;
          }

          .footer-contact-info {
            max-width: 100%;
            text-align: left;
            align-self: flex-start;
            width: 100%;
          }
          
          .footer-actions {
            align-items: center;
            width: 100%;
          }
          
          .btn-contact1,
          .btn-rdv {
            width: 100%;
            max-width: 300px;
            margin-right: 0;
          }

          /* Mobile - section bas */
          .footer-bottom {
            flex-direction: column;
            text-align: center;
            gap: 15px;
            align-items: center;
          }
          
          .legal-links {
            flex-direction: column;
            gap: 10px;
            align-items: center;
          }
          
          .copyright {
            text-align: center;
            width: 100%;
            order: 2;
          }
          
          .legal {
            text-align: center;
            width: 100%;
            order: 1;
          }
        }
        
        /* Petit mobile */
        @media (max-width: 480px) {
          .footer-nav-row {
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }
          
          .footer-nav button {
            font-size: 0.75rem;
            padding: 10px 5px;
          }
          
          /* HOVER ORIGINAL */
          .footer-nav button:hover {
            color: #ffd400;
          }
          
          .section-subtitle0 {
            font-size: 1.2rem;
          }
          
          .contact-detail {
            font-size: 0.85rem;
          }

          .contact-detail .icon {
            margin-right: 10px;
          }
          
          .btn-contact1,
          .btn-rdv {
            padding: 15px 20px;
            font-size: 0.85rem;
            min-width: auto;
            width: 100%;
            max-width: 300px;
            margin-right: 0;
          }
          
          .btn-rdv {
            padding: 20px;
          }
          
          .footer-bottom {
            font-size: 0.8rem;
          }
          
          .legal-links {
            gap: 8px;
          }
        }
        
        /* Très petit mobile */
        @media (max-width: 360px) {
          .footer-nav-row {
            grid-template-columns: 1fr;
            gap: 5px;
          }
          
          .footer-nav button {
            font-size: 0.8rem;
            padding: 8px 3px;
          }
          
          /* HOVER ORIGINAL */
          .footer-nav button:hover {
            color: #ffd400;
          }
          
          .section-subtitle0 {
            font-size: 1.1rem;
          }
          
          .contact-detail {
            font-size: 0.8rem;
          }

          .contact-detail .icon {
            margin-right: 10px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;